import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import AboutText from "../components/AboutText";

import ScrollingTestimonials from "../components/ScrollingTestimonials";
import SlidePricing from "../components/SlidePricing";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import CardCarousel from "../components/CardCarousel";
import Pricing from "../components/Pricing";

const Home = () => {
  return (
    <div>
      <Navbar />
      <HeroSection />

      <AboutText />
      <CardCarousel />
      <ScrollingTestimonials />
      <SlidePricing />
      <Pricing />
      <Contact />

      <Footer />
    </div>
  );
};

export default Home;
